import { call, put, takeEvery } from 'redux-saga/effects';
import request from '../../utils/request';
import errorMessages from '../../components/Error/messages';
import {
  API_URL_WEBMASTER_SETTINGS,
  API_URL_WEBMASTER_SETTINGS_UPDATE,
} from '../../config';
import * as constants from './constants';
import { getAuthToken } from '../../containers/Auth/token';
import {
  saveSettingsSuccess,
  saveSettingsError,
  getSettingsSuccess,
  getSettingsError,
} from './actions';

function getSettingsRequest(token) {
  const data = JSON.stringify({
    token,
  });
  const url = `${API_URL_WEBMASTER_SETTINGS}?data=${data}`;
  const options = {
    method: 'GET',
  };

  return request(url, options);
}

function* getSettingsFlow() {
  try {
    const token = yield getAuthToken();
    const result = yield call(getSettingsRequest, token);
    const { response } = result;
    if (response.success === 1) {
      yield put(getSettingsSuccess(response.data));
      return;
    }
    throw errorMessages.defaultMessage;
  } catch (error) {
    yield put(getSettingsError(error));
  }
}

function saveSettingsRequest(token, action) {
  const { attributes } = action;
  const options = {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: `data=${JSON.stringify({
      token,
      min_sum: Number(attributes.minSum),
      company: attributes.company,
      paysystem: 'bank',
      currency: 'USD',
      first_name: attributes.firstName,
      last_name: attributes.lastName,
      postcode: attributes.postcode,
      country: attributes.country,
      address: attributes.address,
    })}`,
  };

  return request(API_URL_WEBMASTER_SETTINGS_UPDATE, options);
}

function* saveSettingsFlow(action) {
  try {
    const token = yield getAuthToken();
    const result = yield call(saveSettingsRequest, token, action);
    const { response } = result;
    if (response.success === 1) {
      yield put(saveSettingsSuccess(response.data));
      return;
    }
    throw errorMessages.defaultMessage;
  } catch (error) {
    yield put(saveSettingsError(error));
  }
}

// run in parallel
export default function* rootSaga() {
  yield takeEvery(constants.GET_SETTINGS_REQUEST, getSettingsFlow);
  yield takeEvery(constants.SAVE_SETTINGS_REQUEST, saveSettingsFlow);
}



// WEBPACK FOOTER //
// ./src/containers/Settings/sagas.js